export default {
  title: 'Máscaras',
  name: 'Nome',
  pattern: 'Máscara',
  enabled: 'Ativado'
}
